import {FC, useState} from 'react'
import {useDispatch} from 'react-redux'
import Button from 'jbc-front/components/Button'
import {Spacer} from 'jbc-front/components/presenters/Spacer'
import {Modal} from 'jbc-front/components/presenters/ui/Modal'
import {ButtonRow} from 'jbc-front/components/presenters/layout/ButtonRow'
import {useMutation} from 'hooks/graphql'
import {useQuery} from 'hooks/graphql'
import {notifySuccess} from 'store/actions/notify'
import {asyncError} from 'store/actions/asyncError'
import {Loading} from 'components/ui/Loading'
import {QueryResult, QueryVariables, CONTRACT_DOCUMENTS, DELETE_EMPLOYEE_DOCUMENT_CONTRACT} from './query'
import styles from './CancelModal.scss'

interface CancelModalProps {
  employeeId: string
  contractRequestId: string
}

export const CancelModal: FC<CancelModalProps> = ({employeeId, contractRequestId}) => {
  const dispatch = useDispatch()

  const [isOpen, setIsOpen] = useState<boolean>(false)
  const handleOpen = () => setIsOpen(true)
  const handleClose = () => setIsOpen(false)

  const {data, loading: documentsLoading} = useQuery<QueryResult, QueryVariables>(CONTRACT_DOCUMENTS, {
    fetchPolicy: 'network-only',
    variables: {
      employeeId,
      requestId: contractRequestId,
    },
  })
  const documents = data?.client?.employee?.employeeDocumentContractRequest?.documents || []
  const [deleteContract, {loading}] = useMutation(DELETE_EMPLOYEE_DOCUMENT_CONTRACT)

  const handleAccept = async () => {
    try {
      await deleteContract({variables: {input: {employeeId, contractRequestId}}})
      dispatch(notifySuccess('電子契約送信を取り消しました'))
    } catch (err) {
      dispatch(asyncError(err))
    }
    handleClose()
  }

  return (
    <>
      <Button onClick={handleOpen}>送信取消</Button>
      <Modal isOpen={isOpen} onClose={handleClose} className={styles.modal}>
        <Modal.Header onClose={handleClose}>電子契約送信を取り消す</Modal.Header>
        <Modal.Body className={styles.modalBody}>
          {documentsLoading ? (
            <Loading />
          ) : (
            <>
              <p>下記の書類の電子契約送信を取り消します。</p>
              <ul>
                {documents.map((document) => (
                  <li key={document.id}>・{document.title}</li>
                ))}
              </ul>
              <Spacer size={10} />
              <div className={styles.warning}>
                <p className={styles.warningTitle}>【注意】</p>
                <ul>
                  <li>
                    ・同時に電子契約送信を行ったすべての書類に対して、電子契約が取り消しされます。一部の書類のみ取り消すことはできません。
                  </li>
                  <li>・送信を取り消した書類について、再度電子契約を行うことはできません。</li>
                  <li>・送信を取り消しても電子契約の課金対象になります。</li>
                </ul>
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <ButtonRow>
            <Button onClick={handleClose}>キャンセル</Button>
            <Button primary disabled={loading} onClick={handleAccept}>
              取り消す
            </Button>
          </ButtonRow>
        </Modal.Footer>
      </Modal>
    </>
  )
}
